import { Job } from "planning-portal-library/src/lib/core/domain/models/job";
import { Mapper } from "../../../../../core/base";
import { JobWebEntity } from "./job-web-entity";
import { DateTime, Duration } from "luxon";
import { LocationUpdates } from "planning-portal-library/src/lib/core/domain/models/location-update";
import { LocationUpdateRepositoryMapper } from "../../../locations/location-update-repository/entities/location-update-repository-mapper";
import { LocationUpdateEntity } from "../../../locations/location-update-repository/entities/location-update-entity";

export class JobWebRepositoryMapper extends Mapper<JobWebEntity, Job> {
  mapFrom(param: JobWebEntity): Job {
    const locationUpdateList: LocationUpdates[] = [];
    const locationUpdateMapper = new LocationUpdateRepositoryMapper();
    param.locationUpdates?.forEach((locationUpdate) => {
      const mappedLocationUpdate = locationUpdateMapper.mapFrom(locationUpdate);
      locationUpdateList.push(mappedLocationUpdate);
    });
    return {
      id: param.id,
      jobNumber: param.jobNumber,
      vehicleType: param.vehicleType,
      startAddress: param.startAddress,
      endAddress: param.endAddress,
      startTerminalName: param.startTerminalName,
      endTerminalName: param.endTerminalName,
      jobName: param.jobName,
      jobTemplate: param.jobTemplate,
      jobColor: param.jobColor,
      planName: param.planName,
      startTime: param.startTime ? Duration.fromMillis(DateTime.fromISO(param.startTime!).toMillis()) : undefined,
      endTime: param.endTime ? Duration.fromMillis(DateTime.fromISO(param.endTime!).toMillis()) : undefined,
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distance: param.distance ? `${param.distance}` : undefined,
      distanceDisplay: param.distance ? parseFloat(param.distance) : 0,
      duration: param.duration ? Duration.fromMillis(param.duration) : undefined,
      planId: param.planId,
      capacityType1: param.capacityType1,
      capacityType2: param.capacityType2,
      capacityType3: param.capacityType3,
      qualifications: param.qualifications,
      locationsCount: param.locationsCount,
      locationUpdates: locationUpdateList,
      isScheduled: param.isScheduled,
      wayPoints: param.wayPoints || [],
      createdAt: DateTime.fromISO(param.createdAt ?? ""),
      distributionAreaId : param.distributionAreaId,
      distributionAreaName : param.distributionAreaName,
      hasUpdate: param.hasUpdate,
      startTerminalCity: param.startTerminalCity,
      startTerminalPostalCode: param.startTerminalPostalCode,
      endTerminalCity: param.endTerminalCity,
      endTerminalPostalCode: param.endTerminalPostalCode,
      points: param.points,
      additionalData: param.additionalData || {},
    };
  }

  mapTo(param: Job): JobWebEntity {
    const locationUpdateEntityList: LocationUpdateEntity[] = [];
    const locationUpdateEntityMapper = new LocationUpdateRepositoryMapper();
    param.locationUpdates?.forEach((locationUpdate) => {
      const mappedLocationUpdateEntity = locationUpdateEntityMapper.mapTo(locationUpdate);
      locationUpdateEntityList.push(mappedLocationUpdateEntity);
    });
    return {
      id: param.id,
      jobNumber: param.jobNumber,
      vehicleType: param.vehicleType,
      startAddress: param.startAddress,
      jobName: param.jobName,
      jobTemplate: param.jobTemplate,
      planName: param.planName,
      endAddress: param.endAddress,
      startTerminalName: param.startTerminalName + '',
      endTerminalName: param.endTerminalName + '',
      startTime: param.startTime?.toISOTime(),
      endTime: param.endTime?.toISOTime(),
      startLatitude: param.startLatitude,
      startLongitude: param.startLongitude,
      endLatitude: param.endLatitude,
      endLongitude: param.endLongitude,
      distance: param.distance?.split('')[0],
      duration: param.duration?.toMillis(),
      planId: param.planId,
      capacityType1: param.capacityType1,
      capacityType2: param.capacityType2,
      capacityType3: param.capacityType3,
      qualifications: param.qualifications,
      locationsCount: param.locationsCount,
      locationUpdates: locationUpdateEntityList,
      isScheduled: param.isScheduled,
      createdAt: param.createdAt.toISO(),
      distributionAreaId: param.distributionAreaId,
      distributionAreaName: param.distributionAreaName,
      hasUpdate: param.hasUpdate,
      startTerminalCity: param.startTerminalCity,
      startTerminalPostalCode: param.startTerminalPostalCode,
      endTerminalCity: param.endTerminalCity,
      endTerminalPostalCode: param.endTerminalPostalCode,
      points: param.points,
      additionalData: param.additionalData,
    };
  }
}
